<div class="dialog">
  <div class="dialog-header">
    <div>
      <div class="title">{{ title }}</div>
      <div class="subtitle">{{ subtitle }}</div>
    </div>

    <button mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="content">
    <div class="section-title">Employee Details</div>

    @for (f of readonlyFields; track f.label) {
      <div class="row">
        <div class="label">{{ f.label }}</div>
        <div class="value">{{ f.value }}</div>
      </div>
    }

    @if (allowEditing) {
      <div class="edit-section" [formGroup]="form">
        <div class="edit-grid">
          <mat-form-field appearance="outline">
            <mat-label>Employee Number/ID</mat-label>
            <input matInput formControlName="employeeNumber" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Employment Date</mat-label>
            <input matInput type="date" formControlName="employmentDate" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Birth Date</mat-label>
            <input matInput type="date" formControlName="birthDate" />
          </mat-form-field>
        </div>
      </div>
    }
  </div>

  <div class="footer">
    @if (allowEditing) {
      <button mat-stroked-button type="button" class="cancel-btn" (click)="close()">
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        class="done-btn"
        type="button"
        [disabled]="saveDisabled"
        (click)="save()"
        >
        Save Changes
      </button>
    } @else {
      <button mat-raised-button color="primary" class="done-btn" type="button" (click)="close()">Done</button>
    }

  </div>
</div>
